import React, { Component } from "react";
import ReactDOM from "react-dom";
import eventService from "../../services/eventService";
import slideShowService from "../../services/slideshowService";
import storageService from "../../services/storageService";
import { IBrochurePDFConfig } from "../types/pdfConfig";
import { IAddToPdfButtonProps } from "../types/props";
import { IAddToPdfButtonState } from "../types/states";
import "./addToPdfButtonComponent.scss";
import BrochureDuplicatePdfPromptComponent from "../duplicatePdfPromptComponent/duplicatePdfPrompt.component";

class BrochureAddToPdfButtonComponent extends Component<
  IAddToPdfButtonProps,
  IAddToPdfButtonState
> {
  constructor(props: IAddToPdfButtonProps) {
    super(props);
    this.state = {
      addPDFPromptOpen: false,
      downloadPdfPromptOpen: false,
      duplicatePdfPromptOpen: false,
      disabled: false,
    };
  }

  componentDidMount() {
    eventService.on("pdf-brochure-app:add-disable", this.disable);
    eventService.on("pdf-brochure-app:add-enable", this.enable);
    eventService.on("modal-closed", this.modalClosed);
    eventService.on("modal-closing", this.modalClosing.bind(this));
  }

  componentWillUnmount() {
    eventService.off("pdf-brochure-app:add-disable", this.disable);
    eventService.off("pdf-brochure-app:add-enable", this.enable);
    eventService.off("modal-closed", this.modalClosed);
    eventService.off("modal-closing", this.modalClosing.bind(this));
  }

  render() {
    const portal = ReactDOM.createPortal(
      <button
        onClick={this.clickHandler}
        disabled={this.state.disabled}
        className={this.buttonClasses()}
        data-automation={"global-brochure-pdf-add"}
      >
        <i>+ </i>
        {this.buttonText()}
      </button>,
      document.getElementById("pdf-brochure")
    );
    return (
      <>
        {portal}
        {this.generateModalContent()}
      </>
    );
  }
  buttonText = () => {
    return "Add Selection"
  };
  buttonClasses = () => {
    return "ampri-button-tertiary pdf-add-brochure " + (this.state.disabled == true ? 'disabled':"");
  }
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  enable = () => {
    this.setState({
      disabled: false,
    });
  };

  modalClosing = (event) => {
    if (this.state.addPDFPromptOpen || this.state.downloadPdfPromptOpen) {
      event.preventDefault();
      this.setState({
        addPDFPromptOpen: false,
        downloadPdfPromptOpen: false,
      });
      //timeout required to ensure state is fully set before closing
      setTimeout(() => {
        slideShowService.hideModal();
      }, 1);
    }
  };
  modalClosed = () => {
    this.setState({
      downloadPdfPromptOpen: false,
    });
  };
  generateModalContent = () => {
    if (this.state.duplicatePdfPromptOpen) {
      return (
        <BrochureDuplicatePdfPromptComponent
          confirm={this.closeModel}
        />
      );
    } else return null;
  };
  openTray = () => {
    this.closeModel();
    this.props.openTray();
  };
  clickHandler = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    var brochurePDFConfigs = storageService.brochurePDFConfigs;
    var duplicate = [];
    await slideShowService.currentChapterController
      .getPDFConfig()
      .then((pdfConfig: IBrochurePDFConfig[]) => {
        duplicate = brochurePDFConfigs.filter((config) => {
          return pdfConfig.some(function(config2) {
            return config.meta.protection === config2.meta.protection && 
                    config.meta.category === config2.meta.category && 
                    config.meta.segment === config2.meta.segment &&
                    config.meta.index === config2.meta.index &&
                    config.meta["surrender-schedule"] === config2.meta["surrender-schedule"] &&
                    config.name === config2.name;
          });
        });
      });
    if (duplicate.length > 0) {
      slideShowService.showModal('<div id="pdf-brochure-duplicate--modal"></div>');
      this.setState({
        duplicatePdfPromptOpen: true,
      });
      return;
    }

    // No dupes, just trigger click.
    this.triggerOnClick();
  };
  closeModel = () => {
    this.setState({
      addPDFPromptOpen: false,
      downloadPdfPromptOpen: false,
      duplicatePdfPromptOpen: false,
    });
    slideShowService.hideModal();
  };
  triggerOnClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
      this.closeModel();
    }
  };
}

export default BrochureAddToPdfButtonComponent;
